<div class="pageheader">

</div>

<div class="pagecontent">
  <h3>We've sent you a link which you can use to login to the email address you provided.</h3>
</div>
